window.customElements.define(
  'in-your-homes',
  class InYourHomes extends window.HTMLElement {
    connectedCallback() {
      this.prev = this.querySelector('#prev');
      this.next = this.querySelector('#next');
      this.hasProgressBar = this.hasAttribute('show-progress-bar');
      this.progressBar = this.querySelector('.in-your-homes__progress-bar');

      console.log(this.hasProgressBar);

      this.initSlider();
    }

    initSlider() {
      const slider = new KeenSlider(this.querySelector('.keen-slider'), {
        slides: {
          perView: 1.25,
          spacing: 12,
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 4.25,
              spacing: 12,
            },
          },
        },
        loop: false,
        rubberband: false, // Prevent over-scrolling
        centered: false,
        edgePadding: 12, // Add edge padding
      });

      slider.on('created', () => this.updateProgressBar(slider));
      slider.on('slideChanged', () => this.updateProgressBar(slider));
      slider.on('detailsChanged', () => this.updateProgressBar(slider));

      this.prev.addEventListener('click', () => {
        slider.prev();
      });

      this.next.addEventListener('click', () => {
        slider.next();
      });

      this.slider = slider;
    }

    updateProgressBar(slider) {
      if (!this.hasProgressBar || !this.progressBar) return;

      const details = slider.track.details;
      if (!details) return;
      let progress = details.progress * 100;

      this.progressBar.style.width = `${progress}%`;
    }
  }
);
